import { render, staticRenderFns } from "./PersonalSettingsPage.vue?vue&type=template&id=7a037470&scoped=true"
import script from "./PersonalSettingsPage.vue?vue&type=script&lang=js"
export * from "./PersonalSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./PersonalSettingsPage.vue?vue&type=style&index=0&id=7a037470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a037470",
  null
  
)

export default component.exports